module.exports = __webpack_public_path__ + "static/media/consulting_woodtech.9fca35e6.jpg";